import { render, staticRenderFns } from "./modal_create.vue?vue&type=template&id=939f7c20&scoped=true&"
import script from "./modal_create.vue?vue&type=script&lang=js&"
export * from "./modal_create.vue?vue&type=script&lang=js&"
import style0 from "./modal_create.vue?vue&type=style&index=0&id=939f7c20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939f7c20",
  null
  
)

export default component.exports